import { ZIndexOptions } from '@material-ui/core/styles/zIndex';

const zIndex: ZIndexOptions = {
  drawer: 1310,
  modal: 1500,
  snackbar: 2000,
};

export default zIndex;
